// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";
// Store
import { Store } from "#/store";
// Model
import { Page } from "#/common/interfaces/Page";
import { News } from "#/common/interfaces/News";
import { FastSearchResult } from "#/common/interfaces/FastSearchResult";
import { ListBody } from "@mgs/ci2019-common/src/models/list_body/ListBody";
import { IRegion } from "@mgs/ci2019-common/src/interfaces/IRegion";
import { NextStepNavigationItem } from "../common/interfaces/NextStepNavigationItem";
import { Breadcrumb } from "../common/interfaces/Breadcrumb";

export class PageService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new PageService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getPage(url: string, isInEditMode: boolean): Promise<Page> {
    const urlEncoded = encodeURIComponent(url);
    let queryUrl = Store.instance.ui.appApiUrl + `page?url=${urlEncoded}`;
    if (isInEditMode) {
      queryUrl += "&no_cache=1&mode=edit";
    }

    try {
      const response = await this.http.get<Page>(queryUrl);

      return response.body!;
    } catch (e) {
      if (e.body && e.body.body) {
        return e.body!.body!;
      } else {
        throw e;
      }
    }
  }

  public async fastSerach(
    query: string,
    pageId: number,
    lang: string
  ): Promise<FastSearchResult> {
    let queryUrl = Store.instance.ui.appApiUrl + `fast-search`;

    const response = await this.http.post<FastSearchResult>(
      queryUrl,
      {},
      {
        params: {
          page_id: pageId,
          language: lang,
          query: query,
        },
      }
    );

    return response.body!;
  }

  public async getNews(
    portalId: number,
    limit?: number,
    page?: number,
    topNews?: boolean,
    maxAgeInDays?: boolean
  ): Promise<ListBody<News, undefined>> {
    let url = `${Store.instance.ui.appApiUrl}${portalId}/news`;

    let params = {};
    if (limit) {
      params["epp"] = limit;
    }

    if (limit) {
      params["page_number"] = page;
    }

    if (topNews) {
      params["top_news"] = "1";
    }

    if (maxAgeInDays) {
      params["max_age_in_days"] = maxAgeInDays;
    }

    let response = await this.http.get<ListBody<News, undefined>>(url, {
      params,
    });

    return response.body!;
  }

  public async getRegions() {
    let url = `${Store.instance.ui.appApiUrl}regionen`;
    let response = await this.http.get<IRegion[]>(url);

    return response.body!;
  }

  public async getNextStepNavigation(portalId: number) {
    let url = `${Store.instance.ui.appApiUrl}${portalId}/next-step-navigation`;

    let response = await this.http.get<NextStepNavigationItem[]>(url);

    return response.body!;
  }

  public async getKatalogBreadcrumb(
    pageId: number,
    token: string
  ): Promise<Breadcrumb[]> {
    let url = `${Store.instance.ui.appApiUrl}katalog-breadcrumb`;

    let response = await this.http.get<Breadcrumb[]>(url, {
      params: {
        pageId,
        token,
      },
    });

    return response.body!;
  }

  public async getHeadlineNews(portalId: number): Promise<News[]> {
    let url = `${Store.instance.ui.appApiUrl}${portalId}/headline-news`;

    let response = await this.http.get<News[]>(url);

    return response.body!;
  }

  public async getModellbeschreibung(
    pageId: number,
    token: string
  ): Promise<object | null> {
    let url = `${Store.instance.ui.appApiUrl}modellbeschreibung`;

    let response = await this.http.get<object | null>(url, {
      params: {
        pageId,
        token,
      },
    });

    return response.body!;
  }
}
